export const emailJsData = {
    YOUR_SERVICE_ID:"service_u1m2olg",
    YOUR_TEMPLATE_ID:"template_enl0ite",
    YOUR_USER_ID:"user_1cqDHwbzCNlMLJEhuqs1Y",
}